/**
 * HAST tag names dropped from chat markdown (defense in depth).
 * Omit `input` so GFM task-list checkboxes still render.
 */
export const CHAT_MARKDOWN_DISALLOWED_ELEMENTS = [
  'script',
  'style',
  'iframe',
  'object',
  'embed',
  'form',
  'svg',
  'math',
  'link',
  'meta',
  'base',
  'video',
  'audio',
  'canvas',
  'img',
];

/**
 * Block-level tags to strip by unwrapping in one-line contexts (channel list, pinned preview).
 * Keeps WhatsApp-style inline formatting without headings/tables blowing up the UI.
 */
export const CHAT_MARKDOWN_PREVIEW_UNWRAP_ELEMENTS = [
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'table',
  'thead',
  'tbody',
  'tfoot',
  'tr',
  'th',
  'td',
  'blockquote',
  'pre',
  'hr',
];
